import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import {
  Accordion, AccordionSummary, AccordionDetails, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditItemView from './components/EditItemView';
import EditAttributesAccordion from './components/EditAttributesAccordion';
import { useTranslation } from '../common/components/LocalizationProvider';
import SettingsMenu from './components/SettingsMenu';
import useSettingsStyles from './common/useSettingsStyles';
import useDriverAttributes from '../common/attributes/useDriverAttributes';

const DriverPage = () => {
  const classes = useSettingsStyles();
  const t = useTranslation();

  const [item, setItem] = useState();

  const validate = () => item && item.name && item.uniqueId;
  const driverAttributes = useDriverAttributes(t);

  return (
      <EditItemView
          endpoint="drivers"
          item={item}
          setItem={setItem}
          validate={validate}
          menu={<SettingsMenu />}
          breadcrumbs={['settingsTitle', 'sharedDriver']}
      >
        {item && (
            <>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1">
                    {t('sharedRequired')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <TextField
                      value={item.name || ''}
                      onChange={(event) => setItem({ ...item, name: event.target.value })}
                      label={t('sharedName')}
                  />
                  <TextField
                      value={item.uniqueId || ''}
                      onChange={(event) => setItem({ ...item, uniqueId: event.target.value })}
                      label={t('deviceIdentifier')}
                  />
                </AccordionDetails>
              </Accordion>
              <EditAttributesAccordion
                  attributes={item.attributes}
                  setAttributes={(attributes) => setItem({ ...item, attributes })}
                  definitions={driverAttributes}
              />
            </>
        )}
      </EditItemView>
  );
};

export default DriverPage;
